export default __webpack_public_path__ + "static/media/game_4_l.6439a337.png";